"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._RedirectAllRequestsTo = {
    type: "structure",
    required: ["HostName"],
    members: {
        HostName: {
            shape: {
                type: "string"
            }
        },
        Protocol: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_RedirectAllRequestsTo.js.map